// extracted by mini-css-extract-plugin
export var alignDiscLeft = "w_sJ d_fp d_bG d_dv";
export var alignLeft = "w_rd d_fp d_bG d_dv";
export var alignDiscCenter = "w_sK d_fq d_bD d_dw";
export var alignCenter = "w_bP d_fq d_bD d_dw";
export var alignDiscRight = "w_sL d_fr d_bH d_dx";
export var alignRight = "w_rf d_fr d_bH d_dx";
export var footerContainer = "w_sM d_dW d_bW";
export var footerContainerFull = "w_sN d_dT d_bW";
export var footerHeader = "w_kf d_kf";
export var footerTextWrapper = "w_sP d_w";
export var footerDisclaimerWrapper = "w_km d_km d_ck";
export var badgeWrapper = "w_sQ d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "w_sR d_bz d_bJ d_bN d_bL";
export var wide = "w_sS d_cy";
export var right = "w_sT d_bK";
export var line = "w_fk d_fl d_cv";
export var badgeDisclaimer = "w_sV d_bC d_bP d_bJ";
export var badgeContainer = "w_sW d_bz d_bH d_bP";
export var badge = "w_sX";
export var padding = "w_sY d_c7";
export var end = "w_sZ d_bH";
export var linkWrapper = "w_s0 d_dB";
export var link = "w_mC d_dB";
export var colWrapper = "w_s1 d_cx";
export var consent = "w_f d_f d_bC d_bP";
export var disclaimer = "w_s2 d_bz d_bJ";
export var media = "w_s3 d_bx d_dy";
export var itemRight = "w_s4";
export var itemLeft = "w_s5";
export var itemCenter = "w_s6";
export var exceptionWeight = "w_s7 z_t2";